/**
 * Converte uma string no formato mm:ss (minutos e segundos) em um número em segundos.
 */
export function parseDuration(str) {
    if (str) {
        const match = str.match(/^(\d{2}):(\d{2})$/);

        if (match) {
            const minutes = parseFloat(match[1]);
            const seconds = parseFloat(match[2]);

            return minutes * 60 + seconds;
        }
    }
}
